var icon = require('vue-svgicon')
icon.register({
  'ks-icon-note': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M71.54 48.38V27.65l20.73 20.73M37.62 22a7.51 7.51 0 0 0-7.54 7.54v68.92a7.54 7.54 0 0 0 7.54 7.54h52.76a7.54 7.54 0 0 0 7.54-7.54V44.62L75.31 22z"/>'
  }
})
